"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = void 0;

var getMetadata = function getMetadata(categoriesV2, totalTopicCount) {
  if (Array.isArray(categoriesV2)) {
    return {
      totalTopicCount: totalTopicCount,
      categoriesCount: categoriesV2.length
    };
  }

  return {
    totalTopicCount: totalTopicCount,
    categoriesCount: categoriesV2.children.length
  };
};

exports.getMetadata = getMetadata;